import { useEffect } from 'react';
import { getCurrentUserDirect } from '@timetable/api';
import { useAuthStore } from '@/store/authStore';

export function useAuthInit() {
  const setAuth = useAuthStore((state) => state.setAuth);
  const clearAuth = useAuthStore((state) => state.clearAuth);
  const existingAuth = useAuthStore((state) => ({
    user: state.user,
    session: state.session,
    isAuthenticated: state.isAuthenticated,
  }));

  useEffect(() => {
    const initAuth = async () => {
      // If we already have auth state from persisted storage, verify it's still valid
      if (existingAuth.isAuthenticated && existingAuth.user && existingAuth.session) {
        try {
          // Try to fetch current user to verify session is still valid
          const user = await getCurrentUserDirect();
          if (user) {
            // Session is valid, update user data in case it changed
            setAuth(user, existingAuth.session, user.role, user.school_id);
            return;
          }
        } catch (error) {
          console.error('Session validation error:', error);
        }
        // If we get here, session is invalid
        clearAuth();
        return;
      }

      // No existing auth, try to restore from localStorage
      try {
        const user = await getCurrentUserDirect();
        if (user) {
          // Get session from localStorage
          const sessionStr = window.localStorage.getItem('supabase.auth.token');
          if (sessionStr) {
            const sessionData = JSON.parse(sessionStr);
            const session = sessionData?.currentSession;
            if (session) {
              setAuth(user, session, user.role, user.school_id);
              return;
            }
          }
        }
        clearAuth();
      } catch (error) {
        console.error('Auth initialization error:', error);
        clearAuth();
      }
    };

    initAuth();
  }, [setAuth, clearAuth]);
}
